import React from 'react';
import { FileSpreadsheet, Heart } from 'lucide-react';
import useI18n from '../hooks/useI18n';

const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="border-t bg-card/50 mt-8">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 rounded bg-primary/10 flex items-center justify-center">
              <FileSpreadsheet className="w-3 h-3 text-primary" />
            </div>
            <span className="font-medium text-foreground">{t('app.title')}</span>
            <span>v1.0.0</span>
          </div>
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1">
              {t('footer.builtWith')} <Heart className="w-3 h-3 text-red-400" /> React & FastAPI
            </span>
            <span className="hidden sm:inline text-border">|</span>
            <span>{t('footer.tagline')}</span>
          </div>
          <div className="flex items-center gap-3">
            <kbd className="px-1.5 py-0.5 bg-muted rounded text-[10px] font-mono">Ctrl+K</kbd>
            <span>{t('footer.cmdPalette')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
